import { Link } from 'react-router-dom';
import Instagram from '../assets/images/instagram-icon.png';

const ArticleThumbnail = ({ article }) => {
  // Determine if it's an Instagram post
  const isInstagramPost = article.source === 'instagram';
  
  // For Instagram posts, link directly to the Instagram post
  const linkTo = isInstagramPost ? article.url : `/news/${article.id}`;
  
  // Use the appropriate image source based on the data structure
  const mediaUrl = isInstagramPost ? article.imageUrl : article.image;
  
  // Determine if the content is a video based solely on media_type field
  const isVideo = article.media_type === "VIDEO";
  
  return (
    <a href={linkTo} className="block" target={isInstagramPost ? "_blank" : ""} rel={isInstagramPost ? "noopener noreferrer" : ""}>
      <div className="relative group">
        <div className="overflow-hidden shadow-md transition-all duration-300 hover:shadow-lg">
          <div className="aspect-square relative">
            {isVideo ? (
              <video
                src={mediaUrl}
                alt={article.title}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                muted
                playsInline
                loop
                poster={article.thumbnailUrl || ''}
                onMouseOver={(e) => e.target.play()}
                onMouseOut={(e) => e.target.pause()}
              />
            ) : (
              <img
                src={mediaUrl}
                alt={article.title}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
            )}
            
            {/* Instagram icon in bottom right */}
            <div className="absolute bottom-2 right-2 w-6 h-6 overflow-hidden shadow-md">
              <img 
                src={Instagram} 
                alt="Instagram" 
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
        <div className="mt-2">
          <p className="text-white text-xs font-mori line-clamp-1">{article.title}</p>
          {/* <p className="text-honeysuckle/70 text-xs mt-1 font-mori">{article.date}</p> */}
        </div>
      </div>
    </a>
  );
};

export default ArticleThumbnail;